var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUv(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_149",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 25,
    height: 25
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.831421,
    y: 0.69194,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_149)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.8314 5.69194V1.69194H13.8314V5.69194H11.8314ZM18.4814 8.44194L17.1064 7.06694L19.9064 4.19194L21.3064 5.61694L18.4814 8.44194ZM19.8314 13.6919V11.6919H23.8314V13.6919H19.8314ZM11.8314 23.6919V19.6919H13.8314V23.6919H11.8314ZM7.18142 8.39194L4.33142 5.61694L5.75642 4.21694L8.58142 7.04194L7.18142 8.39194ZM19.8814 21.1919L17.1064 18.3169L18.4564 16.9669L21.3064 19.7169L19.8814 21.1919ZM1.83142 13.6919V11.6919H5.83142V13.6919H1.83142ZM5.75642 21.1919L4.35642 19.7669L7.15642 16.9669L7.88142 17.6419L8.60642 18.3419L5.75642 21.1919ZM12.8314 18.6919C11.1648 18.6919 9.74809 18.1086 8.58142 16.9419C7.41475 15.7753 6.83142 14.3586 6.83142 12.6919C6.83142 11.0253 7.41475 9.60861 8.58142 8.44194C9.74809 7.27527 11.1648 6.69194 12.8314 6.69194C14.4981 6.69194 15.9148 7.27527 17.0814 8.44194C18.2481 9.60861 18.8314 11.0253 18.8314 12.6919C18.8314 14.3586 18.2481 15.7753 17.0814 16.9419C15.9148 18.1086 14.4981 18.6919 12.8314 18.6919ZM12.8314 16.6919C13.9314 16.6919 14.8731 16.3003 15.6564 15.5169C16.4398 14.7336 16.8314 13.7919 16.8314 12.6919C16.8314 11.5919 16.4398 10.6503 15.6564 9.86694C14.8731 9.08361 13.9314 8.69194 12.8314 8.69194C11.7314 8.69194 10.7898 9.08361 10.0064 9.86694C9.22309 10.6503 8.83142 11.5919 8.83142 12.6919C8.83142 13.7919 9.22309 14.7336 10.0064 15.5169C10.7898 16.3003 11.7314 16.6919 12.8314 16.6919Z",
    fill: "#1C1B1F"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUv);
export default __webpack_public_path__ + "static/media/uv.0a25af00c6d14785e1fb9d4fd9d96a3d.svg";
export { ForwardRef as ReactComponent };